export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'mapWeather';
export const ENTITY_EDIT_ROUTE = 'weather/detail';
